import { getModelLink } from "components/LogItem/messages/modelLinks";

// RevenueOpportunity has no name column, so it is labelled by its id.
const SUBJECTS = [
  { label: "Entity", type: "Entity", id: "entity_id", name: "entity_name" },
  { label: "Contact", type: "Contact", id: "contact_id", name: "contact_name" },
  { label: "Case", type: "Case", id: "case_id", name: "case_name" },
  {
    label: "Revenue Opportunity",
    type: "RevenueOpportunity",
    id: "revenue_opportunity_id",
  },
];

/**
 * The records an entry belongs to, for a feed that spans many of them.
 *
 * A campaign's Activity Log mixes events from every entity and contact in it,
 * so each row names its own.
 */
const EntrySubject = ({ item }) =>
  SUBJECTS.filter(subject => item[subject.id]).map(subject => (
    <span key={subject.type}>
      {subject.label}:{" "}
      {getModelLink(item[subject.id], subject.type, {
        label: subject.name ? item[subject.name] : `ID ${item[subject.id]}`,
      })}
    </span>
  ));

export default EntrySubject;
